import * as React from 'react';
import { connectRange } from 'react-instantsearch-core';
import { AccordionItem } from '@grandvisionhq/common';
import FacetInputPriceRange from './FacetInputPriceRange.js';

const ConnectedFacetInputPriceRangeMobile = ({ onChange , refine , id , label , min , max , currentRefinement ,  })=>{
    const handleOnChange = React.useCallback((value)=>{
        onChange && onChange();
        refine(value);
    }, [
        onChange,
        refine
    ]);
    if (min === max) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        id: id,
        label: label,
        headingLevel: "h3"
    }, /*#__PURE__*/ React.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentRefinement,
        facetLabel: label,
        onChange: handleOnChange,
        renderNumber: (value)=>Math.round(value / 100)
    }));
};
var ConnectedFacetInputPriceRangeMobile$1 = connectRange(ConnectedFacetInputPriceRangeMobile);

export { ConnectedFacetInputPriceRangeMobile, ConnectedFacetInputPriceRangeMobile$1 as default };
//# sourceMappingURL=ConnectedFacetInputPriceRangeMobile.js.map
